/* The offer tab on the right edge: open, close, and remember it was taken.

   It does NOT copy. offer-band.js owns the clipboard for both shapes of this
   offer — secure-context write, textarea fallback, and the word "Copied" only
   when the copy actually happened. Two implementations of that would drift,
   and the one that drifted would be the one lying to the shopper.

   Delegated from the document, like the band, so the tab survives being
   re-rendered by a variant change or the theme editor. */
(function () {
  var CLOSE_AFTER_COPY_MS = 900;

  function root() {
    return document.querySelector('.offer-notch');
  }

  /* position: fixed is measured against the nearest transformed ancestor, not
     the viewport, and the product section has several. Moving the tab to the
     body is cheaper and more durable than policing every ancestor's
     transform. */
  function adopt() {
    var el = root();
    if (el && el.parentNode !== document.body) document.body.appendChild(el);
  }

  function setOpen(el, open) {
    el.classList.toggle('is-open', open);
    var tab = el.querySelector('[data-offer-notch-tab]');
    if (tab) tab.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var el = root();
    if (!el) return;

    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;

    if (t.closest('[data-offer-notch-tab]')) {
      e.preventDefault();
      setOpen(el, !el.classList.contains('is-open'));
      return;
    }

    if (t.closest('[data-offer-notch-close]')) {
      e.preventDefault();
      setOpen(el, false);
      return;
    }

    if (t.closest('[data-offer-notch-copy]')) {
      /* No preventDefault: offer-band.js is also listening for this click and
         is the one doing the copying. All that happens here is the tab
         changing what it says, and the card standing open long enough for the
         shopper to see the copy confirmed. */
      el.classList.add('is-taken');
      window.setTimeout(function () { setOpen(el, false); }, CLOSE_AFTER_COPY_MS);
      return;
    }

    if (el.classList.contains('is-open') && !t.closest('.offer-notch')) {
      setOpen(el, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var el = root();
    if (el && el.classList.contains('is-open')) setOpen(el, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adopt);
  } else {
    adopt();
  }
})();